/**
 * Implementación del repositorio de Multimedia usando HTTP
 */

import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env';
import { MultimediaRepository } from '@domain/repositories/multimedia.repository';
import { MultimediaItem } from '@domain/models/multimedia.model';
import { MultimediaItemDto } from '@infra/dto/multimedia.dto';
import { MultimediaMapper } from '@infra/mappers/multimedia.mapper';

function joinUrl(base: string, path: string) {
  return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}

@Injectable({ providedIn: 'root' })
export class MultimediaRepositoryImpl implements MultimediaRepository {
  private http = inject(HttpClient);
  private readonly BASE = joinUrl(environment.apiUrl, '/v1/multimedia');

  getPublicMultimedia(): Observable<MultimediaItem[]> {
    return this.http.get<MultimediaItemDto[]>(this.BASE, {
      params: { filter_type: 'public' }
    }).pipe(
      map(dtos => MultimediaMapper.toDomainList(dtos))
    );
  }

  getPrivateMultimedia(): Observable<MultimediaItem[]> {
    return this.http.get<MultimediaItemDto[]>(this.BASE, {
      params: { filter_type: 'private' }
    }).pipe(
      map(dtos => MultimediaMapper.toDomainList(dtos))
    );
  }
}

